__turbopack_context__.v({
  "audioControls": "video-player-module__YHoR6q__audioControls",
  "audioHeading": "video-player-module__YHoR6q__audioHeading",
  "audioSettings": "video-player-module__YHoR6q__audioSettings",
  "bigPlay": "video-player-module__YHoR6q__bigPlay",
  "buffer": "video-player-module__YHoR6q__buffer",
  "control": "video-player-module__YHoR6q__control",
  "controls": "video-player-module__YHoR6q__controls",
  "error": "video-player-module__YHoR6q__error",
  "loading": "video-player-module__YHoR6q__loading",
  "notice": "video-player-module__YHoR6q__notice",
  "pip": "video-player-module__YHoR6q__pip",
  "pipMessage": "video-player-module__YHoR6q__pipMessage",
  "playIcon": "video-player-module__YHoR6q__playIcon",
  "player": "video-player-module__YHoR6q__player",
  "progress": "video-player-module__YHoR6q__progress",
  "resetSettings": "video-player-module__YHoR6q__resetSettings",
  "rightControls": "video-player-module__YHoR6q__rightControls",
  "seek": "video-player-module__YHoR6q__seek",
  "seekInput": "video-player-module__YHoR6q__seekInput",
  "seekPreview": "video-player-module__YHoR6q__seekPreview",
  "settingValue": "video-player-module__YHoR6q__settingValue",
  "settings": "video-player-module__YHoR6q__settings",
  "settingsBody": "video-player-module__YHoR6q__settingsBody",
  "settingsButton": "video-player-module__YHoR6q__settingsButton",
  "settingsHeading": "video-player-module__YHoR6q__settingsHeading",
  "settingsRow": "video-player-module__YHoR6q__settingsRow",
  "shortcuts": "video-player-module__YHoR6q__shortcuts",
  "skip": "video-player-module__YHoR6q__skip",
  "sourceInfo": "video-player-module__YHoR6q__sourceInfo",
  "speeds": "video-player-module__YHoR6q__speeds",
  "spin": "video-player-module__YHoR6q__spin",
  "srOnly": "video-player-module__YHoR6q__srOnly",
  "surface": "video-player-module__YHoR6q__surface",
  "thumb": "video-player-module__YHoR6q__thumb",
  "time": "video-player-module__YHoR6q__time",
  "title": "video-player-module__YHoR6q__title",
  "toggle": "video-player-module__YHoR6q__toggle",
  "toolbar": "video-player-module__YHoR6q__toolbar",
  "track": "video-player-module__YHoR6q__track",
  "video": "video-player-module__YHoR6q__video",
  "volume": "video-player-module__YHoR6q__volume",
  "volumeGroup": "video-player-module__YHoR6q__volumeGroup",
});
